<script>
/**
 * Imports
 */
import axios from "axios";

/**
 * Component: Sections: Agreement
 *
 * The component used for displaying the Base section
 * on signup form. The fields and the data is configured
 * from wp-admin and Sections CPT.
 *
 * @author PH
 */
export default {
  data: function() {
    return {
      l18n: {},
      settings: {},
      documentURL: "",
      loading: false,
      isError: false,
      thankYouURL: window.location.origin + window.location.pathname.replace(/\/?$/, "/") + "thank-you"
    };
  },

  created: function() {
    this.l18n = this.getData("l18n");
    this.settings = this.getData("settings");
  },

  computed: {
    valid: {
      get() {
        return this.$store.getters.getSectionData("agreement", "valid");
      },
      set(value) {
        this.$store.commit("updateSection", {
          section: "agreement",
          values: {
            valid: value
          }
        });
      }
    },

    active() {
      return this.$store.getters.getSectionData("agreement", "active");
    },

    next() {
      return this.$store.getters.getSectionData("agreement", "next");
    },

    api() {
      return this.getData("settings").api;
    },

    submitLabel() {
      if (this.settings.submitLabel) {
        return this.settings.submitLabel;
      }
      return this.l18n.agreement.sign;
    }
  },

  methods: {
    /**
     * Submit: Form
     *
     * @author PH
     * @return void
     */
    submitForm: function(e) {
      e.preventDefault();

      if (false == this.loading) {
        this.loading = true;

        const data = this.$store.getters.sections.map(section => {
          if (! section.fields) {
            return section;
          }

          section.fields = section.fields.filter(field => field.visible === false ? false : true);

          return section;
        });

        if (data) {
          this.createApplication(data).then(response => {
            if (response.data.id) {
              const delegateSigning = this.$store.getters.getSectionSettings(
                "agreement",
                "delegate_signing"
              );
              if (delegateSigning && delegateSigning.status === true) {
                this.delegateDocument(response.data.id).then(response => {
                  if (response) {
                    this.loading = false;
                    window.location = this.thankYouURL;
                  } else {
                    this.isError = true;
                  }
                });
              } else {
                this.createDocument(response.data.id).then(response => {
                  this.documentURL = response.data.url;
                });
              }
            }
          });
        }
      }
    },

    /**
     * Create Application
     *
     * @author PH
     * @return void
     */
    createApplication: function(payload) {
      const api = this.$store.getters.getSectionSettings("agreement", "api");

      return axios
        .put(
          this.api.base + this.api.endpoints.createApplication,
          {
            data: payload,
            nonce: api.submitNonce
          },
          {
            headers: {
              "X-WP-Nonce": api.nonce
            }
          }
        )
        .catch(error => {
          this.loading = false;
          this.isError = true;
          console.error(error.response.data);
        });
    },

    /**
     * Create Document
     *
     * @author PH
     * @return void
     */
    createDocument: function(id) {
      const api = this.$store.getters.getSectionSettings("agreement", "api");

      return axios
        .get(this.api.base + this.api.endpoints.createDocument, {
          params: {
            application: id,
            nonce: api.submitNonce
          },
          headers: {
            "X-WP-Nonce": api.nonce
          }
        })
        .catch(error => {
          this.isError = true;
          console.error(error.response.data);
        });
    },

    /**
     * Delegate Document
     *
     * @author MS
     * @return void
     */
    delegateDocument: function(id) {
      const api = this.$store.getters.getSectionSettings("agreement", "api");

      return axios
        .get(this.api.base + this.api.endpoints.delegateDocument, {
          params: {
            application: id,
            nonce: api.submitNonce
          },
          headers: {
            "X-WP-Nonce": api.nonce
          }
        })
        .catch(error => {
          this.isError = true;
          console.error(error.response.data);
        });
    },

    /**
     * Get: Data
     *
     * @author PH
     * @return string|bool
     */
    getData: function(property) {
      if (property) {
        return this.$store.getters.getSectionData("agreement", property);
      }
      return false;
    }
  }
};
</script>

<template>
  <div
    class="signup-section signup-section-agreement"
    :class="{ valid: valid === true, invalid: valid === false }"
    v-if="active"
  >
    <form action method="POST" @submit="submitForm">
      <div class="signup-section__header">
        <h2>{{getData('header')}}</h2>
        <p class="big">{{l18n.agreement.signDescription}}</p>
      </div>

      <div class="signup-section__error" v-if="isError">
        <p>{{l18n.submit.error}}</p>
      </div>

      <div class="signup-section__footer">
        <div class="signup-section__submit" :class="{loading: loading}">
          <button type="submit">
            <div class="loader">
              <svg class="circular-loader" viewBox="25 25 50 50">
                <circle
                  class="loader-path"
                  cx="50"
                  cy="50"
                  r="20"
                  fill="none"
                  stroke="#FFFFFF"
                  stroke-width="2"
                />
              </svg>
            </div>
            {{submitLabel}}
          </button>
        </div>
      </div>
    </form>

    <transition name="fade">
      <div class="signup-section-agreement-modal" v-if="documentURL">
        <div class="signup-section-agreement-modal__wrap">
          <iframe :src="documentURL" id="signup-section-agreement-iframe"></iframe>
        </div>
      </div>
    </transition>
  </div>
</template>

